module.exports = __webpack_public_path__ + "static/media/tarja-linhas-facial.585636c7.jpg";